import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styles } from './lifegraph-explorer-helper';
import { tuneSliderIconSvg } from '../../../../assets';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface FilterContainerProps {
    collapse: boolean;
    toggleFilterView: () => void;
}

export const FilterContainer = ({
    collapse,
    toggleFilterView,
}: FilterContainerProps): React.JSX.Element => {
    return (
        <Box sx={styles.filterHeader}>
            <Box sx={styles.filterTitleContainer}>
                <img
                    src={tuneSliderIconSvg}
                    alt='icon'
                    style={styles.filterIcon}
                />
                <Typography sx={styles.filterTitle}>Filters</Typography>
            </Box>
            <Button onClick={toggleFilterView} sx={styles.filterButton}>
                <Typography sx={styles.filterButtonText}>
                    {collapse ? 'hide' : 'show'}
                </Typography>
                <KeyboardArrowDownIcon
                    sx={{
                        ...styles.arrowDownIcon,
                        rotate: `${collapse ? '180deg' : '0'}`,
                    }}
                />
            </Button>
        </Box>
    );
};
